import { render, staticRenderFns } from "./listaInscritos.vue?vue&type=template&id=190c86eb&v-if=true&"
import script from "./listaInscritos.vue?vue&type=script&lang=js&"
export * from "./listaInscritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports